/* AMOR: country switcher dialog (snippets/am-locale) and location prompt (snippets/am-geo), 4.11.2026.
   Switcher: buttons [data-am-loc-open] open #AmLoc. Picking a country updates its flag, language, currency and
   shipping note; "Zastosuj" posts Shopify's localization form, and Shopify opens the same page on that market's
   domain (amormeble.pl / amornabytek.cz).
   Prompt: once the page has loaded, asks Shopify where the visitor is (/browsing_context_suggestions.json). A
   country of another market gets #AmGeo in that country's language. It waits while the menu or the switcher is
   open. It does not wait for Shopify's cookie banner: a visitor who switches would have to answer that banner
   twice, once per domain. "Stay" or closing hides it for 30 days (localStorage "amGeo", per domain).
   Both forms add am_loc=1 to the return address. The page opened that way remembers the choice (no prompt on the
   new domain for a visitor who picked it) and removes the parameter from the address bar.
   QA: ?am_geo=CZ (or PL) forces the detected country, ignores the 30-day memory and the bot check.
   Clarity events: lokalizacja_otwarcie, lokalizacja_zmiana, lokalizacja_zapis, lokalizacja_po_zmianie, geo_pokaz,
   geo_przejscie, geo_zostan. */
(function () {
  const root = document.documentElement;
  const ev = (n) => { try { if (window.amClarity) window.amClarity.event(n); } catch (e) { /* no Clarity */ } };
  const lock = (on) => root.classList.toggle('am-modal-open', !!on);
  const openDlg = (d) => {
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    lock(true);
  };
  const closeDlg = (d) => {
    if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
    lock(false);
  };
  // A click on the dimmed backdrop lands on the dialog element itself, outside its box.
  const outside = (d, e) => {
    if (e.target !== d) return false;
    const r = d.getBoundingClientRect();
    return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
  };
  // Marks the return address so the next page knows the visitor chose that market.
  const mark = (form) => {
    const r = form.querySelector('input[name="return_to"]');
    if (!r) return;
    const v = r.value || location.pathname;
    if (!/[?&]am_loc=1(&|$)/.test(v)) r.value = v + (v.indexOf('?') < 0 ? '?' : '&') + 'am_loc=1';
  };
  const KEY = 'amGeo';
  const DAYS = 30;
  const remember = (iso) => { try { localStorage.setItem(KEY, JSON.stringify({ c: iso, t: Date.now() })); } catch (e) { /* storage blocked */ } };
  const dismissed = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || 'null');
      return !!(v && Date.now() - v.t < DAYS * 864e5);
    } catch (e) { return false; }
  };

  /* ---- country switcher ---- */
  const loc = document.getElementById('AmLoc');
  if (loc) {
    const sel = loc.querySelector('#AmLocC');
    const lang = loc.querySelector('[data-am-loc-lang]');
    const cur = loc.querySelector('[data-am-loc-cur]');
    const note = loc.querySelector('[data-am-loc-note]');
    const flag = loc.querySelector('[data-am-loc-flag]');
    const flags = loc.querySelector('template[data-am-loc-flags]');
    const start = { c: sel.value, l: lang.value };
    let langs = {};
    try { langs = JSON.parse(loc.getAttribute('data-am-loc-langs') || '{}'); } catch (e) { langs = {}; }
    const startLangs = Array.from(lang.options).map((o) => [o.value, o.textContent]);

    const sync = () => {
      const o = sel.options[sel.selectedIndex];
      const iso = sel.value;
      const list = iso === start.c ? startLangs : (langs[iso] || startLangs);
      lang.textContent = '';
      list.forEach(([v, t]) => {
        const op = document.createElement('option');
        op.value = v;
        op.textContent = t;
        if (iso === start.c && v === start.l) op.selected = true;
        lang.appendChild(op);
      });
      if (cur && cur.options[0]) cur.options[0].textContent = o.getAttribute('data-cur') || '';
      if (note) {
        const t = o.getAttribute('data-note') || '';
        note.hidden = !t;
        const s = note.querySelector('span');
        if (s) s.textContent = t;
      }
      if (flag && flags) {
        const f = flags.content.querySelector('[data-iso="' + iso + '"]');
        if (f) flag.innerHTML = f.innerHTML;
      }
    };
    sel.addEventListener('change', () => { sync(); ev('lokalizacja_zmiana'); });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-am-loc-open]')) return;
      e.preventDefault();
      document.querySelectorAll('details.am-burger[open]').forEach((d) => d.removeAttribute('open'));
      sel.value = start.c;
      sync();
      openDlg(loc);
      ev('lokalizacja_otwarcie');
    });
    loc.addEventListener('click', (e) => {
      if (e.target.closest('[data-am-loc-close]') || outside(loc, e)) closeDlg(loc);
    });
    loc.addEventListener('close', () => lock(false));
    loc.querySelector('form').addEventListener('submit', (e) => {
      if (sel.value === start.c && lang.value === start.l) { e.preventDefault(); closeDlg(loc); return; }
      mark(e.currentTarget);
      ev('lokalizacja_zapis');
    });
  }

  /* ---- location prompt ---- */
  const geo = document.getElementById('AmGeo');
  const dataEl = document.getElementById('AmGeoData');
  if (!geo || !dataEl) return;
  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const q = new URLSearchParams(location.search);
  if (q.get('am_loc') === '1') {
    // Arrived from the switcher or the prompt on the other domain: the visitor chose this market.
    remember(data.cur);
    ev('lokalizacja_po_zmianie');
    q.delete('am_loc');
    const s = q.toString();
    try { history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) { /* ignore */ }
    return;
  }
  const force = (q.get('am_geo') || '').toUpperCase();
  if (!force) {
    if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|pagespeed|headless|preview/i.test(navigator.userAgent)) return;
    if (dismissed()) return;
  }

  const detect = () => {
    if (force) return Promise.resolve(force);
    return fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => String((j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '').toUpperCase())
      .catch(() => '');
  };
  // Shown when nothing else is open (menu, switcher, cart popup, configurator); gives up after 2 minutes.
  const whenFree = (fn) => {
    const t0 = Date.now();
    const tick = () => {
      const busy = (loc && loc.open) || document.querySelector('details.am-burger[open], .am-pop.is-on, .amx-dlg:not([hidden])');
      if (!busy) return fn();
      if (Date.now() - t0 < 120000) setTimeout(tick, 800);
    };
    tick();
  };
  const show = (iso) => {
    const t = data.t[iso];
    if (!t) return;
    geo.setAttribute('lang', t.lang);
    geo.querySelector('#AmGeoT').textContent = t.title;
    geo.querySelector('#AmGeoD').textContent = t.text;
    geo.querySelector('[data-am-geo-go]').textContent = t.go;
    geo.querySelector('.am-geo__stay').textContent = t.stay;
    geo.querySelector('[data-am-geo-close]').setAttribute('aria-label', t.close);
    geo.querySelector('[data-am-geo-country]').value = iso;
    const fl = geo.querySelector('template[data-am-geo-flags]');
    const f = fl && fl.content.querySelector('[data-iso="' + iso + '"]');
    if (f) geo.querySelector('[data-am-geo-flag]').innerHTML = f.innerHTML;
    openDlg(geo);
    ev('geo_pokaz');
  };
  const stay = () => { remember(data.cur); closeDlg(geo); ev('geo_zostan'); };
  geo.addEventListener('click', (e) => {
    if (e.target.closest('[data-am-geo-stay]') || outside(geo, e)) stay();
  });
  geo.addEventListener('cancel', (e) => { e.preventDefault(); stay(); });
  geo.querySelector('form').addEventListener('submit', (e) => { mark(e.currentTarget); ev('geo_przejscie'); });

  const run = () => detect().then((iso) => {
    if (!iso || iso === data.cur || data.countries.indexOf(iso) < 0) return;
    whenFree(() => show(iso));
  });
  if (document.readyState === 'complete') setTimeout(run, 1200);
  else window.addEventListener('load', () => setTimeout(run, 1200), { once: true });
})();
